require("./visualMapContinuous");

require("./visualMapPiecewise");


//////////////////
// WEBPACK FOOTER
// ../~/echarts/lib/component/visualMap.js
// module id = O34C
// module chunks = 0